import { Injectable } from '@angular/core';
import { Logger } from 'tslog';
import { getUserNoteApi } from '../utils/api/openapi-utils';
import { UserNotesResponse } from '../generated/api';

@Injectable({
  providedIn: 'root'
})
export class UserNoteServiceNEW {
  private log = new Logger({
    name: 'UserNoteServiceNEW',
  });

  public async getUserNotes(contentId: string): Promise<UserNote[]> {
    const api = await getUserNoteApi();
    const notes = await api.listUserNotes({
      contentId: contentId
    });
    return notes;
  }

  public async updateUserNote(params: { content: string, userNoteId: string }): Promise<UserNote> {
    const api = await getUserNoteApi();
    const updatedNote = await api.updateUserNote({
      id: params.userNoteId,
      userNotesUpdateQuery: {
        content: params.content,
      }
    });
    return updatedNote;
  }

  public async createUserNote(params: { contentId: string, contentNoteId: string, content: string}): Promise<UserNote> {
    const api = await getUserNoteApi();
    const createdNote = await api.createUserNote({
      userNotesRequestQuery: {
        contentId: params.contentId,
        noteId: params.contentNoteId,
        content: params.content,
      }
    });
    return createdNote;
  }


  public async deleteUserNote(userNoteId: string): Promise<boolean> {
    const api = await getUserNoteApi();
    const response = await api.deleteUserNote({
      id: userNoteId,
    });
    return response?.success ? true : false;
  }
}

export type UserNote = UserNotesResponse